var exports = {
  "vK": "PremiumUpsellBanner.module__banner___LXdmMW",
  "Qs": "PremiumUpsellBanner.module__content___LXdmMW",
  "Qq": "PremiumUpsellBanner.module__text___LXdmMW",
  "Wz": "PremiumUpsellBanner.module__communityRow___LXdmMW",
  "ju": "PremiumUpsellBanner.module__communityIcon___LXdmMW",
  "nG": "PremiumUpsellBanner.module__communityMore___LXdmMW",
  "rT": "PremiumUpsellBanner.module__previewRow___LXdmMW",
  "kH": "PremiumUpsellBanner.module__previewItem___LXdmMW",
  "yY": "PremiumUpsellBanner.module__previewEmojiText___LXdmMW",
};

module.exports = exports;
